export const formatCurrency = money => {
  return money ? money.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : null;
};
